import script from "./BotGeocodingCoverage.vue?vue&type=script&setup=true&lang=js"
export * from "./BotGeocodingCoverage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__